import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { BarChart3, Target, DollarSign, ArrowLeft, Download } from "lucide-react";
import { useFactsheetDownload } from "@/hooks/useFactsheetDownload";

const DistMediumPortfolio = () => {
  const { downloadFactsheet, loading: downloadLoading } = useFactsheetDownload();
  return (
    <div className="py-8">
      <section className="bg-gradient-to-br from-primary to-accent text-primary-foreground py-16">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <Badge className="mb-4 bg-primary-foreground text-primary">Dist Range - Balanced Income</Badge>
            <h1 className="text-4xl md:text-5xl font-bold mb-6">Dist-Medium Portfolio</h1>
            <p className="text-xl text-primary-foreground/90 max-w-3xl mx-auto mb-4">
              Balanced Income Strategy for Moderate Growth and Income
            </p>
            <div className="flex justify-center items-center gap-8 text-lg mb-6">
              <div><span className="font-semibold">Risk Level:</span> Medium</div>
              <div><span className="font-semibold">Target Yield:</span> 4%+</div>
              <div><span className="font-semibold">Benchmark:</span> CPI + 2%</div>
            </div>
            <Button 
              variant="outline" 
              onClick={() => downloadFactsheet('DIST_MEDIUM')}
              disabled={downloadLoading}
              className="bg-primary-foreground/10 border-primary-foreground/20 text-primary-foreground hover:bg-primary-foreground/20"
            >
              <Download className="h-4 w-4 mr-2" />
              {downloadLoading ? 'Downloading...' : 'Download Factsheet'}
            </Button>
          </div>
        </div>
      </section>

      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-8">
        <Button variant="outline" asChild className="mb-8">
          <Link to="/portfolios/dist"><ArrowLeft className="h-4 w-4 mr-2" />Back to Dist Range</Link>
        </Button>

        <section className="mb-16">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold mb-6">Portfolio Overview</h2>
              <p className="text-lg text-muted-foreground mb-6">
                The Dist-Medium portfolio balances income generation with moderate capital growth potential. 
                Suitable for balanced investors seeking regular distributions alongside some portfolio appreciation.
              </p>
            </div>
            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <Target className="h-5 w-5" />Key Characteristics
                </CardTitle>
              </CardHeader>
              <CardContent>
                <ul className="space-y-3">
                  <li className="flex items-center">
                    <div className="w-2 h-2 bg-primary rounded-full mr-3" />Balanced income/growth approach
                  </li>
                  <li className="flex items-center">
                    <div className="w-2 h-2 bg-primary rounded-full mr-3" />Diversified income sources
                  </li>
                  <li className="flex items-center">
                    <div className="w-2 h-2 bg-primary rounded-full mr-3" />Moderate risk profile
                  </li>
                </ul>
              </CardContent>
            </Card>
          </div>
        </section>

        <Card className="text-center">
          <CardContent className="p-8">
            <h3 className="text-2xl font-bold mb-4">Interested in Dist-Medium?</h3>
            <p className="text-muted-foreground mb-6">Discover how our balanced income strategy can provide steady distributions with growth potential.</p>
            <Button size="lg" asChild><Link to="/contact">Schedule a Consultation</Link></Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default DistMediumPortfolio;